<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1200"
  >
    <v-card class="table-card">
      <v-toolbar>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('queues.reports.callDetails.details.title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="callDetails"
        :disable-sort="true"
        :options.sync="callDetailsPagination"
        :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
        class="report-table"
        dense
      >
        <template v-slot:[`item.time`]="{ item }">
          {{ formatDate(item.time) }}
        </template>
          <template v-slot:[`item.callerId`]="{ item }">
          {{ formatClid(item.callerId) }}
        </template>
        <template v-slot:item.event="{ item }">
          {{ $t(`queues.reports.eventDetails.events.${item.event}`) ?
            $t(`queues.reports.eventDetails.events.${item.event}`) :
            $t('queues.reports.eventDetails.events.notMapped') }}
        </template>
        <template v-slot:item.agent_display="{ item }">
          {{ formatAgent(item.agent_display) }}
        </template>
        <template v-slot:item.wait="{ item }">
          {{ hourTemplate(item.wait) }}
        </template>
        <template v-slot:item.duration="{ item }">
          {{ hourTemplate(item.duration) }}
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
import formatPhoneNum from '@/filters/phone_num'
import { formatDateReduced } from '@/filters/format_date'
import formatTime from '@/filters/format_time'
import formatClid from '@/filters/format_clid'
import API from '@/api'
import events from 'Store/events'

export default {
  name: 'call_details_dialog',
  props: {
    scope: {
      type: String,
      default: 'month'
    },
    timezone: {
      type: String,
      default: 'UTC'
    }
  },
  data () {
    return {
      dialog: false,
      callDetails: [],
      callDetailsPagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      }
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('queues.reports.callDetails.details.table.time'), value: 'time', width: 150 },
        { text: this.$t('queues.reports.callDetails.details.table.callerId'), value: 'callerId' },
        { text: this.$t('queues.reports.callDetails.details.table.event'), value: 'event' },
        { text: this.$t('queues.reports.callDetails.details.table.agent'), value: 'agent_display' },
        { text: this.$t('queues.reports.callDetails.details.table.queue'), value: 'queuename' },
        { text: this.$t('queues.reports.callDetails.details.table.wait'), value: 'wait', align: 'center', width: 120 },
        { text: this.$t('queues.reports.callDetails.details.table.duration'), value: 'duration', align: 'center', width: 120 }
      ]
    }
  },
  methods: {
    formatDate (date) {
      return formatDateReduced(date, this.scope, this.$i18n.locale)
    },
    formatClid (clid) {
      if (!clid) {
        return ''
      } else if (clid.indexOf('"') !== -1) {
        return clid.replaceAll('"', '')
      } else {
        return formatPhoneNum(clid)
      }
    },
    formatAgent (agent) {
      if (agent === 'NONE') return this.$t('queues.reports.none')
      return formatClid(agent)
    },
    hourTemplate (seconds) {
      if (!seconds) return '00:00'
      return formatTime(seconds)
    },
    loadCallDetails (callId) {
      events.mask(this.$t('queues.reports.callDetails.details.loading'))
      API.getQueueEventLogsByCall(callId, this.timezone).then((res) => {
        this.callDetails = res.data
        this.callDetailsPagination.page = 1
        this.dialog = true
      }).catch((err) => {
        this.dbg(err.response)
        events.pubError({ key: 'queues.reports.callDetails.details.loadFail' })
      }).finally(() => {
        events.unmask()
      })
    }
  }
}
</script>
